module.exports = __webpack_public_path__ + "static/cisco-9a08b41a147b76138eb6d0402d0fe450.png";